<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} News Category</h3>
            </div>
            <v-form class="v-form-body" ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <label class="form-control-label">Name
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="category.name"
                    placeholder="Enter Category Name"
                    :rules="[(v) => !!v || 'Category Name is required!',  (v) => v && !!v.trim() || 'Field cannot be blank']"
                    required
                    solo
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pb-6">
                  <label class="form-control-label">Parent Category</label>
                  <treeselect
                    v-model="category.parentCat"
                    :normalizer="normalizer"
                    placeholder="Select your Category"
                    :show-count="true"
                    search-nested
                    :options="categories"
                  />
                </v-col>
                <v-col class="text-right" cols="12">
                  <v-btn
                    color="#989898"
                    class="mr-4 white--text"
                    @click="cancel"
                    >Cancel</v-btn
                  >
                  <v-btn
                    :disabled="!valid"
                    color="#344452"
                    class="white--text"
                    :loading="loading"
                    @click="validate"
                    >{{(isEdit) ? 'Update' : 'Save'}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { NewscategoryService } from "@/services";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "AddNewsCategory",
  components: {
    CommonSection,
    Treeselect,
  },
  data() {
    return {
      loading: false,
      open: ["public"],
      valid: true,
      normalizer(node) {
        return {
          id: node._id,
          label: node.name,
          children: node.childs,
        };
      },
      categories: [],
      category: {
        name: null,
        parentCat: null,
      },
      isEdit: false
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== 'create') {
        this.isEdit = true;
        const category = await NewscategoryService.getCategory(
          this.$route.params.id
        );
        this.category.name = category.data.data[0].name;
        this.category.parentCat = category.data.data[0].parentCat;
      }
      const categoryList = await NewscategoryService.getCategoryList();
      categoryList.data = categoryList.data.map((obj) => {
        delete obj.childs;
        return obj;
      });
      this.categories = categoryList.data;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let response;
          if (this.$route.params.id !== 'create') {
            response = await NewscategoryService.updateNewsCategory({
              id: this.$route.params.id,
              object: {
                name: this.category.name,
                parentCat:
                  this.category.parentCat === null ? "" : this.category.parentCat,
              },
            });
          } else {
            response = await NewscategoryService.createCategory({
              name: this.category.name,
              parentCat:
                this.category.parentCat === null ? "" : this.category.parentCat,
            });
          }
          this.loading = false;
          if (response) {
            this.$router.push("/news-category");
            this.$store.dispatch(
              "user/setSnack",
              `News category ${(this.isEdit) ? 'updated' : 'added'} successfully!`
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    cancel() {
      this.$router.push('/news-category');
    }
  },
};
</script>
